import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import Header from './header';
import ByLine from './by_line';
import Article from './article';
import Footer from './footer';
import Social from '../../social/social';

export default class Body extends Component {
  getByLineAttribution(tags) {
    let bylineAttribution = '';

    forEach(tags, tag => {
      if (
        tag.name.indexOf('byline_') !== -1 ||
        tag.slug.indexOf('byline-') !== -1
      ) {
        bylineAttribution = tag.name.replace('byline_', '');
      }
    });

    return bylineAttribution;
  }

  renderKiaAdWords() {
    const { post } = this.props;
    const { tags } = post;
    const isKia = tags.filter(tag => tag.slug === 'kia_niro').length;

    // TODO: refactor to use scriptjs and fire js
    if (isKia) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html:
              '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }}
        />
      );
    }

    return null;
  }

  render() {
    const {
      post,
      advertorial,
      isFirstPost,
      combinedAdModel,
      videoAdData,
      config,
      pageNum,
      isLongPost,
      hasNewsletter
    } = this.props;
    const { tags, content: article } = post;
    const emptyContent = !article.length;
    const currentSite = get(config, 'site');
    const bylineAttribution = this.getByLineAttribution(tags);

    return (
      <div className="post__body" data-id={post.id} data-slug={post.slug}>
        <Header
          currentSite={currentSite}
          tags={tags}
          advertorial={advertorial}
          post={post}
          combinedAdModel={combinedAdModel}
          isFirstPost={isFirstPost}
          videoAdData={videoAdData}
        />

        <div className="post__container">
          <Social
            enableSticky={this.props.isDesktop}
            empty={emptyContent}
            text={encodeURIComponent(get(post, 'title') || '')}
            uri={post.link}
            modifier="post"
            bottomBoundary={`#social--${post.id}`}
            encapsulateId={`social--${post.id}`}
          />
          <div className="post__content">
            {isLongPost
              ? <ByLine post={post} bylineAttribution={bylineAttribution} />
              : null}
            <Article
              post={post}
              combinedAdModel={combinedAdModel}
              pageNum={pageNum}
              isShortPost={!isLongPost}
            />
            <Footer
              post={post}
              site={currentSite}
              env={config.env}
              bylineAttribution={bylineAttribution}
              isLongPost={isLongPost}
              hasNewsletter={hasNewsletter}
            />
            {this.renderKiaAdWords()}
          </div>
        </div>
      </div>
    );
  }
}

Body.defaultProps = {
  isDesktop: false,
  hasNewsletter: false
};

Body.propTypes = {
  post: PropTypes.shape({}).isRequired,
  advertorial: PropTypes.bool.isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  config: PropTypes.shape({}).isRequired,
  videoAdData: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  pageNum: PropTypes.number.isRequired,
  isLongPost: PropTypes.bool.isRequired,
  hasNewsletter: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/body.js